/** Phase 18 — supermarketInvoices lesen. */

import { listAggregateSupermarketInvoices } from '../infrastructure/storage/domainAggregateStore';
import { listEntitySupermarketInvoices } from '../infrastructure/storage/entityAggregateStore';
import { createArrayEntityReadSource } from './arrayEntityReadSourceFactory';

const source = createArrayEntityReadSource({
  field: 'supermarketInvoices',
  listAggregate: listAggregateSupermarketInvoices,
  listEntity: listEntitySupermarketInvoices,
  idKeys: ['id', 'invoiceNumber']
});

export const readSupermarketInvoicesFromMergedBlob = source.readFromMergedBlob;
export const readSupermarketInvoicesFromBestSource = source.readFromBestSource;
export const refreshSupermarketInvoicesReadCache = source.refreshReadCache;
export const getCachedSupermarketInvoicesRead = source.getCachedRead;
export const clearSupermarketInvoicesReadCache = source.clearReadCache;
export const readSupermarketInvoicesSyncForBusiness = source.readSyncForBusiness;
